export default "__VITE_ASSET__d728cd5b__"